import { useTranslation } from "react-i18next";
import InstanceIcon, { INSTANCE_ICONS } from "./InstanceIcon";

export default function IconPicker({ value, onChange, disabled = false, ButtonComponent = "button" }) {
  const { t } = useTranslation("spaces");
  return (
    <div className="iio-icon-picker ci-icon-picker" role="group" aria-label={t("feld.symbol")}>
      {Object.keys(INSTANCE_ICONS).map(name => (
        <ButtonComponent key={name} type="button" disabled={disabled}
          className={`iio-icon-pick${value === name ? " is-active" : ""}`}
          aria-label={t(`symbol.${name}`)} aria-pressed={value === name}
          title={t(`symbol.${name}`)} onClick={() => onChange(name)}>
          <InstanceIcon name={name}/>
        </ButtonComponent>
      ))}
    </div>
  );
}
